import * as types from "./../types";

const state = {
  operationQueryIso: "",
  wallet: {},
  bankCard: [],
  depositCurrencies: [],
  withdrawCurrencies: [],
  exchangeCurrencies: [],
  transferCurrencies: [],
  processingOrder: {},
  isOrderExpired: false,
  orderStep: {},
  cancelOrderStep: "",
  isCountdownReset: ""
};

const getters = {
  [types.operations.getters.GET_OPERATION_QUERY_ISO]: state => {
    return state.operationQueryIso;
  },
  [types.operations.getters.GET_CANCEL_ORDER_STEP]: state => {
    return state.cancelOrderStep;
  },
  [types.operations.getters.GET_ORDER_STEP]: state => {
    return state.orderStep;
  },
  [types.operations.getters.GET_WALLET]: state => {
    return state.wallet;
  },
  [types.operations.getters.GET_BANK_CARD]: state => {
    return state.bankCard;
  },
  [types.operations.getters.GET_DEPOSIT_CURRENCIES]: state => {
    return state.depositCurrencies;
  },
  [types.operations.getters.GET_WITHDRAW_CURRENCIES]: state => {
    return state.withdrawCurrencies;
  },
  [types.operations.getters.GET_EXCHANGE_CURRENCIES]: state => {
    return state.exchangeCurrencies;
  },
  [types.operations.getters.GET_TRANSFER_CURRENCIES]: state => {
    return state.transferCurrencies;
  },
  [types.operations.getters.GET_PROCESSING_ORDER]: state => {
    return state.processingOrder;
  },
  [types.operations.getters.GET_ORDER_EXPIRATION_STATUS]: state => {
    return state.isOrderExpired;
  },
  [types.operations.getters.GET_COUNTDOWN_STATUS]: state => {
    return state.isCountdownReset;
  }
};

const mutations = {
  [types.operations.mutations.MUTATE_OPERATION_QUERY_ISO]: (state, payload) => {
    state.operationQueryIso = payload;
  },
  [types.operations.mutations.MUTATE_CANCEL_ORDER_STEP]: (state, payload) => {
    state.cancelOrderStep = payload;
  },
  [types.operations.mutations.MUTATE_ORDER_STEP]: (state, payload) => {
    state.orderStep = payload;
  },
  [types.operations.mutations.MUTATE_WALLET]: (state, payload) => {
    state.wallet = payload;
  },
  [types.operations.mutations.MUTATE_BANK_CARD]: (state, payload) => {
    state.bankCard = payload;
  },
  [types.operations.mutations.MUTATE_DEPOSIT_CURRENCIES]: (state, payload) => {
    let data = [];
    payload.wallets.forEach(elem => {
      if (elem.is_deposit_active && elem.currency.iso !== "IRR") {
        data.push(elem);
      }
    });
    state.depositCurrencies = data;
  },
  [types.operations.mutations.MUTATE_WITHDRAW_CURRENCIES]: (state, payload) => {
    let data = [];
    payload.wallets.forEach(elem => {
      if (elem.is_withdraw_active && elem.currency.iso !== "IRR") {
        data.push(elem);
      }
    });
    state.withdrawCurrencies = data;
  },
  [types.operations.mutations.MUTATE_EXCHANGE_CURRENCIES]: (state, payload) => {
    let data = [];
    payload.wallets.forEach(elem => {
      if (elem.is_change_active && elem.currency.iso !== "IRR") {
        data.push(elem);
      }
    });
    state.exchangeCurrencies = data;
  },
  [types.operations.mutations.MUTATE_TRANSFER_CURRENCIES]: (state, payload) => {
    let data = [];
    payload.wallets.forEach(elem => {
      if (
        elem.is_transfer_to_market_place_active &&
        elem.currency.iso !== "IRR"
      ) {
        data.push(elem);
      }
    });
    state.transferCurrencies = data;
  },
  [types.operations.mutations.MUTATE_PROCESSING_ORDER]: (state, payload) => {
    state.processingOrder = payload;
  },
  [types.operations.mutations.MUTATE_ORDER_EXPIRATION_STATUS]: (
    state,
    payload
  ) => {
    state.isOrderExpired = payload;
  },
  [types.operations.mutations.MUTATE_COUNTDOWN_STATUS]: (state, payload) => {
    state.isCountdownReset = payload;
  }
};

const actions = {
  [types.operations.actions.SET_OPERATION_QUERY_ISO]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_OPERATION_QUERY_ISO, payload);
  },
  [types.operations.actions.ACTION_CANCEL_ORDER_STEP]: (
    { commit },
    payload
  ) => {
    commit(types.operations.mutations.MUTATE_CANCEL_ORDER_STEP, payload);
  },
  [types.operations.actions.ACTION_ORDER_STEP]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_ORDER_STEP, payload);
  },
  [types.operations.actions.SET_WALLET]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_WALLET, payload);
  },
  [types.operations.actions.SET_BANK_CARD]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_BANK_CARD, payload);
  },
  [types.operations.actions.SET_DEPOSIT_CURRENCIES]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_DEPOSIT_CURRENCIES, payload);
  },
  [types.operations.actions.SET_WITHDRAW_CURRENCIES]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_WITHDRAW_CURRENCIES, payload);
  },
  [types.operations.actions.SET_EXCHANGE_CURRENCIES]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_EXCHANGE_CURRENCIES, payload);
  },
  [types.operations.actions.SET_TRANSFER_CURRENCIES]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_TRANSFER_CURRENCIES, payload);
  },
  [types.operations.actions.ACTION_PROCESSING_ORDER]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_PROCESSING_ORDER, payload);
  },
  [types.operations.actions.ACTION_ORDER_EXPIRATION_STATUS]: (
    { commit },
    payload
  ) => {
    commit(types.operations.mutations.MUTATE_ORDER_EXPIRATION_STATUS, payload);
  },
  [types.operations.actions.ACTION_COUNTDOWN_STATUS]: ({ commit }, payload) => {
    commit(types.operations.mutations.MUTATE_COUNTDOWN_STATUS, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
